import { z } from "zod";
import { LocalDateSchema, PlanningOpaqueIdSchema, PlanningRequestIdSchema } from "./planning";

export const WorkspaceCalendarKindSchema = z.enum([
  "school_holiday",
  "public_holiday",
  "travel",
  "sick",
  "custom",
]);

export const WorkspaceCalendarPeriodSchema = z
  .object({
    name: z.string().trim().min(1).max(120),
    start_local_date: LocalDateSchema,
    end_local_date: LocalDateSchema,
  })
  .strict()
  .refine((value) => value.end_local_date >= value.start_local_date, {
    message: "calendar period end must not be earlier than start",
    path: ["end_local_date"],
  });

export const WorkspaceCalendarSchema = z
  .object({
    id: PlanningOpaqueIdSchema,
    workspace_id: PlanningOpaqueIdSchema,
    name: z.string().min(1).max(160),
    kind: WorkspaceCalendarKindSchema,
    periods: z.array(WorkspaceCalendarPeriodSchema).min(1).max(64),
    child_ids: z.array(PlanningOpaqueIdSchema).min(1).max(20),
    version: z.number().int().min(1),
    created_at: z.number().int(),
    updated_at: z.number().int(),
    archived_at: z.number().int().nullable(),
  })
  .strict();

const WorkspaceCalendarMutationFieldsSchema = z
  .object({
    name: z.string().trim().min(1).max(160),
    kind: WorkspaceCalendarKindSchema,
    periods: z.array(WorkspaceCalendarPeriodSchema).min(1).max(64),
    child_ids: z.array(PlanningOpaqueIdSchema).min(1).max(20),
  })
  .strict()
  .refine((value) => new Set(value.child_ids).size === value.child_ids.length, {
    message: "child_ids must be unique",
    path: ["child_ids"],
  });

export const CreateWorkspaceCalendarRequestSchema = WorkspaceCalendarMutationFieldsSchema;
export const UpdateWorkspaceCalendarRequestSchema = WorkspaceCalendarMutationFieldsSchema.extend({
  expected_version: z.number().int().min(1),
}).strict();

export const WorkspaceCalendarListResponseSchema = z
  .object({ items: z.array(WorkspaceCalendarSchema), request_id: PlanningRequestIdSchema })
  .strict();

export const WorkspaceCalendarMutationResponseSchema = z
  .object({
    calendar: WorkspaceCalendarSchema,
    idempotency_replayed: z.boolean(),
    sync_cursor: z.string().min(1),
    request_id: PlanningRequestIdSchema,
  })
  .strict();

export const WorkspaceCalendarArchiveCommandRequestSchema = z
  .object({ expected_version: z.number().int().min(1) })
  .strict();

export const WorkspaceCalendarArchiveCommandResponseSchema = z
  .object({
    calendar: WorkspaceCalendarSchema,
    command: z.enum(["archive", "restore"]),
    idempotency_replayed: z.boolean(),
    sync_cursor: z.string().min(1),
    request_id: PlanningRequestIdSchema,
  })
  .strict();
